import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  floatyButtonsContainer: {
    position: "absolute",
    top: "20px",
    right: "20px",
    "@media (min-width: 992px)": {
      top: "unset",
      right: "unset"
    },
    display: "flex",
    flexDirection: "row-reverse",
    gap: "10px"
  }
});

export function FloatyButtonsContainer({ children }) {
  const classes = useStyles();
  return <div className={classes.floatyButtonsContainer}>{children}</div>;
}

FloatyButtonsContainer.propTypes = {
  children: PropTypes.node
};
